import { combineReducers } from "redux";

import { authReducer } from "./auth/auth.reducer";
import { BrandReducer } from "./Brand/Brand.reducer";
import { BannerReducer } from "./Banner/Branner.reducer";
import { userReducer } from "./Users/users.reducer";
import { AttributeReducer } from "./Attribute/Attribute.reducer";
import { CategoryReducer } from "./Category/Category.reducer";
import { ProductReducer } from "./Product/Product.reducer";
import { CustomerCategoryReducer } from "./CustomerCategory/CustomerCategory.reducer";
import { ProductCategoryReducer } from "./ProductCategory/ProductCategory.reducer";
import { userPiReducer } from "./UserPi/usersPi.reducer";

const RootReducer = combineReducers({
  auth: authReducer,
  brand: BrandReducer,
  banner: BannerReducer,
  users: userReducer,
  userPi: userPiReducer,
  attribute: AttributeReducer,
  category: CategoryReducer,
  productCategory: ProductCategoryReducer,
  product: ProductReducer,
  customerCategory: CustomerCategoryReducer,
});

export default RootReducer;
